"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

require("../listeners/focusStylesListener");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _CheckboxConstants = require("./CheckboxConstants");

var _Functions = require("../core/Functions");

var _underscore = require("../utils/underscore");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _FieldsetContext = require("../context/FieldsetContext");

// Prevent unwanted focus styles
var renderIndicator = (0, _memoize.default)(function (color) {
  return _react.default.createElement("span", {
    className: "private-checkbox__indicator private-radio__indicator",
    "data-indicator": true,
    style: {
      color: color
    }
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, _react.default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    className: "private-radio__circle",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), _react.default.createElement("circle", {
    className: "private-radio__dot",
    id: "a",
    cx: "10",
    cy: "10",
    r: "5"
  }))));
});

var UIRadioInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIRadioInput, _Component);

  function UIRadioInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIRadioInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIRadioInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        event.preventDefault();
        return;
      }

      (0, _Functions.callIfPossible)(onChange, event);
    };

    return _this;
  }

  (0, _createClass2.default)(UIRadioInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          alignment = _this$props2.alignment,
          ariaLabelledBy = _this$props2['aria-labelledby'],
          checked = _this$props2.checked,
          children = _this$props2.children,
          className = _this$props2.className,
          color = _this$props2.color,
          defaultChecked = _this$props2.defaultChecked,
          description = _this$props2.description,
          descriptionLayout = _this$props2.descriptionLayout,
          disabled = _this$props2.disabled,
          id = _this$props2.id,
          inline = _this$props2.inline,
          labelClassName = _this$props2.labelClassName,
          name = _this$props2.name,
          __onChange = _this$props2.onChange,
          readOnly = _this$props2.readOnly,
          size = _this$props2.size,
          text = _this$props2.text,
          value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["alignment", "aria-labelledby", "checked", "children", "className", "color", "defaultChecked", "description", "descriptionLayout", "disabled", "id", "inline", "labelClassName", "name", "onChange", "readOnly", "size", "text", "value"]);
      var _this$context = this.context,
          fieldSize = _this$context.size,
          fieldDisabled = _this$context.disabled;
      var computedText = children || text;
      var computedDescId = description ? (0, _underscore.uniqueId)('checkbox-') : null;
      var longhandSize = (0, _tshirtSize.toLonghandSize)(size || fieldSize);
      var computedDisabled = disabled || fieldDisabled;

      if (children && text) {
        _devLogger.default.warn({
          message: 'UIRadioInput: `children` or `text` should be specified, not both.',
          key: 'UIRadioInput: children and text given'
        });
      }

      return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('private-radio', className, _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.SIZE_OPTIONS[longhandSize], {
          'private-checkbox': computedText,
          'private-checkbox--disabled': computedDisabled,
          'private-checkbox--readonly': readOnly,
          'private-checkbox--inline': inline,
          'private-checkbox--flush': !computedText,
          'private-checkbox--stack-contents': description && descriptionLayout === 'vertical'
        })
      }), _react.default.createElement("label", {
        className: (0, _classnames.default)('private-checkbox__label', labelClassName)
      }, _react.default.createElement("span", {
        className: "private-checkbox__inner"
      }, _react.default.createElement("input", {
        "aria-describedby": computedDescId,
        "aria-labelledby": ariaLabelledBy,
        checked: checked,
        className: (0, _classnames.default)('sr-only', 'private-checkbox__input'),
        defaultChecked: defaultChecked,
        disabled: computedDisabled,
        id: id,
        name: name,
        onChange: this.handleChange,
        readOnly: readOnly,
        type: "radio",
        value: value
      }), renderIndicator(color), computedText ? _react.default.createElement("span", {
        className: (0, _classnames.default)('private-checkbox__text', {
          'private-checkbox__text--small': longhandSize === 'small'
        })
      }, computedText) : null)), description && _react.default.createElement("span", {
        className: "private-checkbox__desc",
        id: computedDescId
      }, description));
    }
  }]);
  return UIRadioInput;
}(_react.Component);

exports.default = UIRadioInput;
UIRadioInput.contextType = _FieldsetContext.FieldsetContext;
UIRadioInput.propTypes = {
  alignment: _propTypes.default.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
  'aria-labelledby': _propTypes.default.string,
  checked: _propTypes.default.bool,
  children: _propTypes.default.node,
  color: _propTypes.default.string,
  defaultChecked: _propTypes.default.bool,
  description: _propTypes.default.node,
  descriptionLayout: _propTypes.default.oneOf(['horizontal', 'vertical']),
  disabled: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  labelClassName: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _propTypes.default.oneOf(['default'])]),
  text: _propTypes.default.node,
  value: _propTypes.default.any
};
UIRadioInput.defaultProps = {
  alignment: 'start',
  descriptionLayout: 'vertical'
};
UIRadioInput.displayName = 'UIRadioInput';
module.exports = exports.default;